module.exports = __webpack_public_path__ + "static/main4-en-1de7bb0a47fe26972d1434d441d729f4.png";